const features = [
  {
    icon: 'ri-flashlight-line',
    title: '每日更新，内容新鲜',
    desc: '平台运营团队全天候追踪最新黑料动态，确保每日都有新鲜爆料内容推送，让您永远走在吃瓜第一线。',
    color: 'primary',
  },
  {
    icon: 'ri-shield-check-line',
    title: '多方验证，信息可靠',
    desc: '每一条爆料内容均经过多方交叉验证，杜绝虚假信息传播，为用户提供真实可信的黑料视频观看体验。',
    color: 'accent',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端覆盖，随时观看',
    desc: '支持网页端与移动端无缝切换，无论使用电脑还是手机都能获得流畅的黑料视频在线播放体验。',
    color: 'secondary',
  },
  {
    icon: 'ri-folder-open-line',
    title: '分类清晰，查找便捷',
    desc: '按娱乐圈、网红圈、体育圈等领域精细分类，帮您快速定位感兴趣的黑料视频合集内容。',
    color: 'primary',
  },
  {
    icon: 'ri-lock-line',
    title: '隐私保护，安全访问',
    desc: '采用先进的隐私保护技术，确保您的浏览记录和个人信息得到最严格的保密，安全放心使用平台。',
    color: 'accent',
  },
];

const colorMap: Record<string, { bg: string; text: string; iconBg: string }> = {
  primary: { bg: 'bg-primary-100', text: 'text-primary-600', iconBg: 'bg-primary-500' },
  accent: { bg: 'bg-accent-100', text: 'text-accent-600', iconBg: 'bg-accent-500' },
  secondary: { bg: 'bg-secondary-100', text: 'text-secondary-600', iconBg: 'bg-secondary-500' },
};

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-900 mb-3">平台特色</h2>
          <p className="text-foreground-500 text-sm max-w-xl mx-auto">91黑料网打造行业领先的黑料视频平台，五大优势为您保驾护航</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5 max-w-6xl mx-auto">
          {features.map((item, i) => {
            const c = colorMap[item.color];
            return (
              <div
                key={i}
                className="bg-background-100 rounded-xl p-5 border border-background-200/60 hover:border-primary-200/60 transition-all duration-300 text-center group cursor-default"
              >
                <div
                  className={`w-12 h-12 rounded-xl ${c.bg} flex items-center justify-center mx-auto mb-4`}
                >
                  <i className={`${item.icon} text-xl ${c.text}`} />
                </div>
                <h3 className="text-sm font-bold text-foreground-800 mb-2">{item.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}